/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayFrom, parseHtml, parseDate, sortFn, getId, fmt } from '../../twd/twd'

export const SelectHolding = ({cusip, setCusip, holdings,}) => {

    const cusips = []
    const rs = arrayFrom(holdings)
        .filter(({cusip}) => {
            if (cusips.indexOf(cusip)>=0) return false
            cusips.push(cusip)
            return true
        })
        .filter(({maturity}) => {
            const isMatured = parseDate(maturity) < Date.now()
            return !isMatured
        })
        .sort(sortFn(({issue, maturity}) => {
            return (issue || '').trim() + fmt.fmtDt(parseDate(maturity), 'yyyy-MM-dd')
        }))
    const isDisabled = rs.length===0

    const id = getId()

    return <React.Fragment>
        <div className="vertical-offset-base">
        <div><label
            className="label" htmlFor={id}
            style={{ lineHeight:'20px', display:'inline'}}
        >Holdings</label>
        </div>

        <div>
        <div className='select-wrapper vertical-offset-xxs'>
            <select
                id={id}
                data-name="calculator-enter-cusip-select-holdings"
                defaultValue={cusip || ''}
                disabled={isDisabled}
                aria-disabled={isDisabled}
                onChange={(e) => {
                    const newCusip = e.target.value
                    if (!newCusip) return

                    setCusip(newCusip)
                }}
                className="form-control text-truncate"
                style={{paddingRight:'25px'}}
            >
            { rs.length>0 && [{cusip:'', issue:'Select'}].concat(rs).map( (a,i) => {
                return <option
                    data-name="calculator-enter-cusip-select-holdings-option"
                    key={i}
                    value={a.cusip || ''}
                    selected={a.cusip === cusip}
                    >{parseHtml(a.issue || '')}</option>
            })}
            </select>
        </div>
        </div>
        </div>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/calculator/cusip-input/select-holding.js